import React from 'react';
import { Content as ContentStyled } from '../styles';

export const Content = ({ children, fullWidth }) => (
  <ContentStyled className="builder-content" {...{ fullWidth }}>
    {children}
  </ContentStyled>
);
